export type RtcUnsupportedReason = 'insecure_context' | 'peer_connection_unavailable';

export interface RtcSupportStatus {
  supported: boolean;
  reason?: RtcUnsupportedReason;
  has_media_devices: boolean;
  has_get_user_media: boolean;
  has_peer_connection: boolean;
  is_secure_context: boolean;
}

/**
 * SDK 在创建 engine 后才会访问 RTCPeerConnection；在此之前预检可避免旧 Android
 * WebView 把不支持误报成一次 RTC 进房失败。getUserMedia 不是 RTC 的硬前提：
 * avatar 可以只订阅远端媒体，编辑页也可以使用上传或屏幕输入。
 */
export const getRtcSupportStatus = (): RtcSupportStatus => {
  if (typeof window === 'undefined') {
    return {
      supported: false,
      reason: 'peer_connection_unavailable',
      has_media_devices: false,
      has_get_user_media: false,
      has_peer_connection: false,
      is_secure_context: false,
    };
  }

  const mediaDevices = typeof navigator === 'undefined' ? undefined : navigator.mediaDevices;
  const isSecureContext = window.isSecureContext !== false;
  const hasPeerConnection = typeof window.RTCPeerConnection === 'function';

  return {
    supported: isSecureContext && hasPeerConnection,
    ...(isSecureContext
      ? hasPeerConnection
        ? {}
        : { reason: 'peer_connection_unavailable' }
      : { reason: 'insecure_context' }),
    has_media_devices: Boolean(mediaDevices),
    has_get_user_media: typeof mediaDevices?.getUserMedia === 'function',
    has_peer_connection: hasPeerConnection,
    is_secure_context: isSecureContext,
  };
};
